import React, {Component} from 'react';
import { Card, Container, Row, Col, Form, Media, Badge } from "react-bootstrap";
import { listTotalAdmin } from '../../actions/adminActions';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import { toast } from'react-toastify';
import { socket } from '../../actions/fetchActions';
import { decodedTranslatorToken } from '../../helpers/decode-token';
import appConfig from 'appConfig';

import FrontendChatbox  from './FrontendChatbox';
var moment = require('moment'); 
class FrontEndChat extends Component{
    constructor( props ){
        super( props );
        this.state = {
            total_admins:[],
            page:1,
            current_number:'',
            total_number:'',
            errors: {},
            per_page:10,
            total_pages:null,
            translatorLoading:false,
            searchInput:'',
            searchTranslator:'',
            adminId:null,
            adminDetails:null,
            room:null,
        } 
    }

    componentDidMount(){
        const { page, total_pages, per_page, searchTranslator, adminId, room  } = this.state;
        this.getAdmin( page, per_page, searchTranslator  );
        var translatorId = decodedTranslatorToken.userId;
        socket.on('message', message => {
            if(message.receiverId == translatorId){
                var receiverId = translatorId;
                var type = "translator"
                if(receiverId !== null){

                    socket.emit('change-message-status', {room, receiverId,type});
                }
                this.getAdmin( page, per_page, searchTranslator  );
            }
        });

        socket.on('change-status-response', message => {

            if(message.receiverId == translatorId){
                
                this.getAdmin( page, per_page, searchTranslator  );
            }

        });
    }

    getAdmin = async ( page, per_page, searchTranslator  ) => {
        this.setState({ translatorLoading: false })
        var translatorId = decodedTranslatorToken.userId;
        
        await this.props.listTotalAdmin(searchTranslator, translatorId);
        if(this.props.total_admins.response){

            var translators = this.props.total_admins.users;

            translators.sort(function(a, b) {
                if(a.chat_room !== undefined && b.chat_room !== undefined){
                    var keyA = new Date(a.chat_room.createdAt);
                    var keyB = new Date(b.chat_room.createdAt);
                    // Compare the 2 dates
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                }else if(a.chat_room === undefined){
                    return 1;
                }else if(b.chat_room === undefined){
                    return -1;
                }
                return 0;
            });
            this.setState({
                total_admins: this.props.total_admins.users,
                translatorLoading: false
            })
        }else{
            this.setState({ translatorLoading: false })
            toast.dismiss()
            toast.error( this.props.total_admins.message, { position: toast.POSITION.TOP_RIGHT, hideProgressBar: true })
        }
    }

    handleOnChange = (e, parameter) => {
        let fields = this.state.fields
       
        this.setState({searchTranslator: e.target.value})
        const { page, total_pages, per_page, searchTranslator  } = this.state;
        this.getAdmin( page, per_page, e.target.value  );
    }

    ImageExist = (url) => 
    {
      var img = new Image();
      img.src = url;
      if(img.src.indexOf('null') == -1 ){

        return true;
      }
      return false;
    }

    selectAdmin = (adminId, adminDetails) => {
        this.setState({adminId: adminId, adminDetails: adminDetails})

        var translatorId = decodedTranslatorToken.userId;

        socket.emit('join_room', { translatorId, adminId }, (error) => {
            if(error) {
                alert(error);
            }
        });

        socket.on("roomData", room  => {
            
            if(room.translatorId == translatorId && room.adminId == adminId){

                this.setState({ room : room.room })
            }
        });

    }



    componentDidUpdate = async (prevProps) => {
        //Typical usage, don't forget to compare the props
        if (this.props.adminId !== prevProps.adminId && window.location.path !=='/') {
            let total_admins = this.state.total_admins;
            var translatorId = decodedTranslatorToken.userId;
            var adminDetails = total_admins.find(t => t._id == this.props.adminId)
            this.selectAdmin(this.props.adminId, adminDetails) 
            socket.on('message', message => {
                if(message.receiverId == translatorId){
                    var receiverId = translatorId;
                    var type = "translator"
                    if(receiverId !== null){
    
                        socket.emit('change-message-status', {room, receiverId,type});
                    }
                    this.getAdmin( page, per_page, searchTranslator  );
                }
            }); 

            socket.on('change-status-response', message => {
    
                if(message.receiverId == translatorId){
                    
                    this.getAdmin( page, per_page, searchTranslator  );
                }
    
            });
        }
    }

    componentWillUnmount(){
        var translatorId = decodedTranslatorToken.userId;
        var type = 'translator';
        socket.disconnect();
    }

    timeSince = (date) => {

        let new_date = new Date(date);

        var seconds = Math.floor((new Date() - new_date) / 1000);
      
        var interval = seconds / 31536000;
      
        if (interval > 1) {
            return moment(date).format('DD-MM-YYYY') ;
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return moment(date).format('DD-MM-YYYY') ;
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return moment(date).format('DD-MM-YYYY') ;
        }
        interval = seconds / 3600;
        if (interval > 1) {
          return Math.floor(interval) + " hours ago";
        }
        interval = seconds / 60;
        if (interval > 1) {
          return Math.floor(interval) + " minutes ago";
        }
        if(seconds == -1){
            seconds = 1;
        }
        return Math.floor(seconds) + " seconds ago";
    }

    render(){
        const { total_admins, translatorLoading, adminId, room, adminDetails } = this.state;
        var translatorId = decodedTranslatorToken.userId;
        return (
            <Container fluid className="p-sm-0">
                <Row className="mb-4">
                    <Col sm={12}>
                        <Card className="border-0 rounded-0 p-2 chatWidget">
                            <Row>
                                <Col sm={12} lg={4}>
                                    
                                    <Form.Group>
                                        <Form.Control type="text" placeholder="Search here" onChange={(e) => this.handleOnChange(e, 'searchTranslator')} value={this.state.searchTranslator} />
                                        <i className="fas fa-search"></i>
                                    </Form.Group>
                                    <div className="chatList">
                                    { translatorLoading ?
                                        <div style={{ textAlign:'center' }} className="col-sm-12 col-sm-offset-5" > 
                                            <Loader className="align-self-center" type="Audio" color="#000" height={30} width={30} />
                                        </div>
                                        :  
                                        total_admins.length > 0 ?
                                        <>
                                        {total_admins.map(( t, i ) => {
                                            return (
                                            <Media className={t._id == adminId ? "selected-translator" : ""}>
                                
                                                <Link onClick={() => this.selectAdmin(t._id, t)}>
                                                  <span className="userIcon">
                                                    <img src={this.ImageExist(`${appConfig.REACT_APP_SERVER_PATH}`+`/profile/`+`${t.profile}`) ? `${appConfig.REACT_APP_SERVER_PATH}`+`/profile/`+`${t.profile}`  : require("assets/img/default-avatar.png")}
                                                        onError={(e)=>{{
                                                            e.target.onerror = null;
                                                            e.target.src= require("assets/img/default-avatar.png");
                                                            }}}
                                                     alt="..." 
                                                    width={35}
                                                    height={35}
                                                    style={{borderRadius: "50%"}}
                                                    />
                                                    
                                                    <Badge variant={t.online_status ? "success" : "secondary"}></Badge>
                                                  </span>
                                                  
                                                </Link>
                                                <Media.Body onClick={() => this.selectAdmin(t._id,t)}>
                                                    <h5>{t.fullname}</h5>
                                                    {   t.chat_room ?
                                                    <span style={{cursor:'pointer'}}><i class="fas fa-check mr-1" style={{ color:t.chat_room ? t.chat_room.read ? '#2bb0a2' : 'black': '#fdfdfd',cursor:'pointer'}} ></i>{t.chat_room ? t.chat_room.message : ''} </span>
                                                    :''}
                    
                                                </Media.Body>
                                            </Media>
                                            )
                                        })}
                                        </>
                                        :
                                        <div style={{ textAlign:'center' }} className="col-sm-12 col-sm-offset-5" >
                                            <p style={{textTransform:'uppercase', textAlign:'center'}}>
                                                Sorry, No Translators to show
                                            </p>
                                            </div>
                                    }
                                        
                                    </div>
                                </Col>
                                <Col sm={12} lg={8}>
                                    <div className="chatBox">
                                        {adminDetails !== null && adminDetails !== undefined && room !== null? <FrontendChatbox adminDetails={adminDetails} room={room} senderId={translatorId} receiverId={adminId} getAdmin={this.getAdmin} type='translator' /> : ''}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}

const mapStateToProps = state => {
  const { admin } = state
  return {
    total_admins: admin.listAdmin
  }
}
const dispatchAction = { listTotalAdmin }
export default connect(mapStateToProps, dispatchAction)(FrontEndChat);